module.exports = __webpack_public_path__ + "e42bb94875c1fa8a191dd89c2d736a76.pdf";